import { render, staticRenderFns } from "./UiNotifications.vue?vue&type=template&id=6ea1a3f9"
import script from "./UiNotifications.vue?vue&type=script&lang=js"
export * from "./UiNotifications.vue?vue&type=script&lang=js"
import style0 from "./UiNotifications.vue?vue&type=style&index=0&id=6ea1a3f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports